import type {SVGProps} from 'react'
import * as React from 'react'
const LoadedErrorIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="121" height="120" fill="none" viewBox="0 0 121 120" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M120.5 100.69C120.5 84.4067 93.6371 71.2068 60.5 71.2068C27.3629 71.2068 0.5 84.4067 0.5 100.69C0.5 116.972 120.5 116.972 120.5 100.69Z"
      fill="url(#paint0_linear_17513_3502)"
    />
    <g opacity="0.8">
      <g opacity="0.8">
        <path opacity="0.8" d="M15.5 82.9739V89.4394" stroke="#AECFFF" strokeWidth="2.66667" strokeLinecap="round" />
        <path
          opacity="0.8"
          d="M15.3268 69.9998C11.4058 74.1161 9.7149 77.2467 10.254 79.3915C11.0626 82.6086 14.2807 83.1032 15.0761 83.1032C15.8715 83.1032 20.5011 83.1643 20.5011 78.8762C20.5011 76.0175 18.7763 73.0587 15.3268 69.9998Z"
          fill="#D2E4FF"
        />
      </g>
      <g opacity="0.8">
        <path opacity="0.8" d="M101.707 81.53V86.0559" stroke="#AECFFF" strokeWidth="2" strokeLinecap="round" />
        <path
          opacity="0.8"
          d="M101.705 72.4138C98.9606 75.3386 97.777 77.563 98.1544 79.0869C98.7204 81.3728 100.973 81.7242 101.53 81.7242C102.087 81.7242 105.327 81.7676 105.327 78.7208C105.327 76.6896 104.12 74.5873 101.705 72.4138Z"
          fill="#D7E7FF"
        />
      </g>
      <g opacity="0.8">
        <path opacity="0.8" d="M112.742 87.7046V91.2606" stroke="#AECFFF" strokeWidth="2" strokeLinecap="round" />
        <path
          opacity="0.8"
          d="M112.914 81.0344C110.823 83.2009 109.921 84.8486 110.208 85.9774C110.64 87.6707 112.356 87.931 112.78 87.931C113.204 87.931 115.673 87.9631 115.673 85.7063C115.673 84.2017 114.754 82.6444 112.914 81.0344Z"
          fill="#D7E7FF"
        />
      </g>
    </g>
    <path
      opacity="0.603585"
      d="M61.8786 59.1052L56.5314 71.3792L29.4648 64.3997"
      stroke="#E8F1FF"
      strokeWidth="0.666667"
    />
    <g filter="url(#filter0_f_17513_3502)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.3008 78.9011H46.4292L64.295 87.7369H54.5415L37.3008 78.9011Z"
        fill="url(#paint1_linear_17513_3502)"
      />
    </g>
    <path d="M64.2919 75.8621H54.6367V87.931H64.2919V75.8621Z" fill="url(#paint2_linear_17513_3502)" />
    <g filter="url(#filter1_f_17513_3502)">
      <path
        d="M61.8782 76.724C61.8782 76.4384 61.6467 76.2068 61.361 76.2068C61.0753 76.2068 60.8438 76.4384 60.8438 76.724V87.4137C60.8438 87.6993 61.0753 87.9309 61.361 87.9309C61.6467 87.9309 61.8782 87.6993 61.8782 87.4137V76.724Z"
        fill="white"
      />
    </g>
    <path
      d="M62.4457 37.2381L84.2257 68.4561C85.7513 70.6428 85.2154 73.6521 83.0288 75.1776C82.2186 75.7429 81.2544 76.046 80.2665 76.046H36.7065C34.0403 76.046 31.8789 73.8846 31.8789 71.2184C31.8789 70.2305 32.182 69.2663 32.7473 68.4561L54.5273 37.2381C56.0528 35.0515 59.0621 34.5156 61.2488 36.0411C61.7151 36.3665 62.1204 36.7717 62.4457 37.2381Z"
      fill="url(#paint3_linear_17513_3502)"
    />
    <path
      d="M64.5161 37.2381L86.2961 68.4561C87.8216 70.6428 87.2857 73.6521 85.0991 75.1776C84.2889 75.7429 83.3247 76.046 82.3368 76.046H38.7768C36.1106 76.046 33.9492 73.8846 33.9492 71.2184C33.9492 70.2305 34.2523 69.2663 34.8176 68.4561L56.5976 37.2381C58.1231 35.0515 61.1324 34.5156 63.3191 36.0411C63.7854 36.3665 64.1907 36.7717 64.5161 37.2381Z"
      fill="url(#paint4_linear_17513_3502)"
    />
    <path
      d="M63.9512 49.6553C63.9512 47.7509 62.4074 46.207 60.503 46.207C58.5985 46.207 57.0547 47.7509 57.0547 49.6553V59.3105C57.0547 61.2149 58.5985 62.7588 60.503 62.7588C62.4074 62.7588 63.9512 61.2149 63.9512 59.3105V49.6553Z"
      fill="url(#paint5_linear_17513_3502)"
    />
    <path
      d="M60.503 72.4139C62.4074 72.4139 63.9512 70.87 63.9512 68.9656C63.9512 67.0612 62.4074 65.5173 60.503 65.5173C58.5985 65.5173 57.0547 67.0612 57.0547 68.9656C57.0547 70.87 58.5985 72.4139 60.503 72.4139Z"
      fill="url(#paint6_linear_17513_3502)"
    />
    <path
      d="M62.5719 49.6553C62.5719 48.1318 61.3369 46.8967 59.8133 46.8967C58.2898 46.8967 57.0547 48.1318 57.0547 49.6553V59.3105C57.0547 60.8341 58.2898 62.0691 59.8133 62.0691C61.3369 62.0691 62.5719 60.8341 62.5719 59.3105V49.6553Z"
      fill="white"
    />
    <path
      d="M59.8133 71.7243C61.3369 71.7243 62.5719 70.4892 62.5719 68.9657C62.5719 67.4421 61.3369 66.207 59.8133 66.207C58.2898 66.207 57.0547 67.4421 57.0547 68.9657C57.0547 70.4892 58.2898 71.7243 59.8133 71.7243Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_f_17513_3502"
        x="35.9674"
        y="77.5678"
        width="29.6628"
        height="11.5026"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="0.666667" result="effect1_foregroundBlur_17513_3502" />
      </filter>
      <filter
        id="filter1_f_17513_3502"
        x="55.5104"
        y="70.8735"
        width="11.7018"
        height="22.3908"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="2.66667" result="effect1_foregroundBlur_17513_3502" />
      </filter>
      <linearGradient
        id="paint0_linear_17513_3502"
        x1="60.5"
        y1="71.2068"
        x2="60.5"
        y2="109.62"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E0EDFF" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_17513_3502"
        x1="55.5395"
        y1="83.0848"
        x2="55.7606"
        y2="84.0732"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#418EFF" stopOpacity="0" />
        <stop offset="1" stopColor="#418EFF" stopOpacity="0.5" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_17513_3502"
        x1="54.6367"
        y1="81.8965"
        x2="64.2919"
        y2="81.8965"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.000184755" stopColor="#8CB9FC" />
        <stop offset="0.736041" stopColor="#DEEBFF" />
        <stop offset="1" stopColor="#CDE1FF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_17513_3502"
        x1="58.4867"
        y1="76.046"
        x2="58.4867"
        y2="35.1724"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.000184755" stopColor="#8AB9FD" />
        <stop offset="1" stopColor="#DFECFF" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_17513_3502"
        x1="60.557"
        y1="72.4376"
        x2="60.557"
        y2="38.5094"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C4DCFF" />
        <stop offset="1" stopColor="#EFF6FF" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_17513_3502"
        x1="60.503"
        y1="62.7588"
        x2="60.503"
        y2="46.207"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.000184755" stopColor="#8AB9FD" />
        <stop offset="1" stopColor="#DFECFF" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_17513_3502"
        x1="60.503"
        y1="72.4139"
        x2="60.503"
        y2="65.5173"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.000184755" stopColor="#8AB9FD" />
        <stop offset="1" stopColor="#DFECFF" />
      </linearGradient>
    </defs>
  </svg>
)
export default LoadedErrorIcon
